module.exports = __WEBPACK_EXTERNAL_MODULE_SJI6__;


//////////////////
// WEBPACK FOOTER
// external "Vuex"
// module id = SJI6
// module chunks = 71